const TextColor = {
  Primary: 'primary',
  Secondary: 'secondary',
  Tertiary: 'tertiary',
  Success: 'success',
  Error: 'error',
  White: 'white',
  Branded: 'branded',
} as const;

type TextColorType = typeof TextColor[keyof typeof TextColor];

export { TextColor, TextColorType };
